import { createContext, useContext } from 'react';
import { substituteCanvasText, textVariablesFor } from './canvasVariables';

// The canvas's variables for the cards that DISPLAY them (2026-10-09): a text
// block's Markdown and title, any block's heading. Display-only on purpose —
// the on-card editors keep editing the stored text with its {key}s. The editor
// page provides the canvas; with no provider (a shared link, whose text the
// server already filled in) text shows as stored.
export const CanvasVariablesContext = createContext(null);

/** `(text) => text` with this block's {key}s filled in from the canvas. */
export function useCanvasText(block) {
  const canvas = useContext(CanvasVariablesContext);
  if (!canvas || !Array.isArray(canvas.variables) || canvas.variables.length === 0) return (text) => text;
  const vars = textVariablesFor(canvas, block);
  return (text) => substituteCanvasText(text, vars);
}
